import React from "react";
import "../../styles/viewDetail.css";

// Read-only label + value row for view modals (description-list style).
// Kept the original name/props for compatibility — it used to render a
// disabled <Input>, which read as a broken form; now it renders plain text.
function LabelWithInputDisabled(props) {
  const empty =
    props.value === undefined || props.value === null || props.value === "";
  return (
    <div className="vd-row">
      <span className="vd-label">{props.label}</span>
      <span className={`vd-value${empty ? " vd-value-empty" : ""}`}>
        {empty ? "—" : props.value}
      </span>
    </div>
  );
}

export default LabelWithInputDisabled;
